import Api from './axios';
import camelCase from '../utils/camelCase';

const search = (
  storeid = 121,
  surfaceCodes = ' ',
  getState
) => {
  const { customBaseUrl, partnerProductId } = getState()?.config;

  // eslint-disable-next-line max-len
  const url = `${customBaseUrl}/countertops/api/surfaceAvailability/${storeid}/${surfaceCodes}/partnerProductId/${partnerProductId}`;

  return Api()
    .get(url)
    .then((response) => response.data)
    .then(camelCase);
};

export default search;
